























































import { Component, Vue } from 'vue-property-decorator';
import { PreferencesAction } from '@/store/PreferencesModule';
import { ChevronsLeftIcon, ChevronsRightIcon } from 'vue-feather-icons';

@Component({ components: { ChevronsRightIcon, ChevronsLeftIcon } })
export default class ToggleMenu extends Vue {
  async handleToggle() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.collapseMenuSetting}`,
      !this.isCollapsedSetting,
    );
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.collapseMenu}`,
      this.isCollapsedSetting,
    );
  }

  async closeMobileMenu() {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.expandMobileMenu}`, false);
  }
  get isCollapsed() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsed`];
  }

  get isCollapsedSetting() {
    return this.$store.getters[`PreferencesModule/isMenuCollapsedSetting`];
  }
}
